<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="text-xl mb-4 mr-8">Unable to delete {{ pluralize(slides.length, 'this slide', 'these slides') }}</h2>
    <div class="text-gray-800 font-light space-y-4">
      <p>{{ pluralize(slides.length, 'This slide is', 'These slides are') }} currently being used for the following:</p>
      <div>
        <p class="font-semibold text-gray-900">Embed(s)</p>
        <ul class="ml-4 mt-1">
          <li v-for="embed in affectedEmbeds.slice(0, 5)" :key="embed.id" class="list-disc list-inside">
            {{ embed.name }}
          </li>
          <li v-if="affectedEmbeds.length > 5" class="mt-1 list-none italic">&hellip;{{ affectedEmbeds.length - 5 }} more&hellip;</li>
        </ul>
      </div>
      <p>To delete, remove or replace {{ pluralize(slides.length, 'this slide', 'these slides') }} in the embed(s) listed above.</p>
    </div>
    <div class="flex flex-row gap-4 mt-8 w-full justify-end">
      <VButton class="w-42" variant="copper" data-testid="close-button" @click="$emit('update:showing', false)">Close</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed } from 'vue'

import type { Slide } from '@/entities/deck'
import type { DeckEmbed } from '@/entities/embed'
import { pluralize } from '@/lib/pluralize'

const props = defineProps({
  slides: {
    type: Array as PropType<Slide[]>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
  deckEmbeds: {
    type: Array as PropType<DeckEmbed[]>,
    default: () => [],
  },
})

defineEmits(['update:showing'])

const affectedEmbeds = computed(() => {
  const slideIds = new Set(props.slides.map(s => s.id))
  return props.deckEmbeds.filter(de => (de.start_slide_id !== null && slideIds.has(de.start_slide_id)) || (de.end_slide_id !== null && slideIds.has(de.end_slide_id)))
})
</script>
